The hirer ID to replay events for.

If you omit this field, behaviour differs based on the scope of the webhook subscription:

- A partner-scoped subscription defaults to replaying all related hirers.
- A hirer-scoped subscription defaults to its corresponding `WebhookSubscription.hirerId`.
